
import React, { Fragment } from 'react'
import { ListGroup } from 'react-bootstrap'

import { useProgrammation } from '@/Hooks/UseProgrammation'
import useTranslation from '@/Hooks/UseTranslation'

import ContentBlock from './components/ContentBlock'
import ResponsibleItem from './components/ResponsibleItem'
import TeamMemberSelector from './components/TeamMemberSelector/TeamMemberSelector'

import './WorksResponsibles.scss'

const WorksResponsibles = () => {

  const { t } = useTranslation()

  const { itemOpened } = useProgrammation()

  return (
    <ContentBlock
      title={t('PROGRAMMATION_MANAGER:SectionResponsiblesTitle') + ` (${itemOpened.responsibles.length})`}
      collapsable
    >
      {itemOpened.subTasks.map((subTask: any) => (
        <Fragment key={subTask._id}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className='work-name'>
              {subTask.name}
            </div>
            <div>
              <TeamMemberSelector subTask={subTask} onSelect={(user: any) => console.log(user)} />
            </div>
          </div>
          <ListGroup>
            {subTask.responsibles.map((r: any, i: number) => (
              <ResponsibleItem
                key={i}
                user={r}
                subTask={subTask}
                onDeleted={() => console.log(r)}
                // canDelete={false}
              />
            ))}
          </ListGroup>
          <div style={{ margin: 4, backgroundColor: '#efefef', height: 1 }}></div>
        </Fragment>
      ))}
    </ContentBlock>
  )
}

export default WorksResponsibles
